const colors = {
  black: '#000000',
  white: '#FFFFFF',
  cornflower: '#66A4F7',
  sun: '#F9E14B',
  aqua: '#6EE4D6',
  cherise: '#EA4D72',
  cherise50: '#E41B4A',
  grey80: '#333333',
  grey30: '#B3B3B3',
  statusRed: '#C80000',
  statusGreen: '#2F8802',
  warningBackground: '#FFF3E5',
  violetBackground: '#EBE4F9',
  greenBackground: '#F5FFF0',
  blueHoverLink: '#00598C',
  ghostWhite: '#F6F9FE',
  azure95: '#E5F1FF',
  peach: '#F87171',
  azure700: '#0F49A8',
  lightPink: '#FECACA',
  yellow800: '#854D0E',
  orange600: '#EA580C',
  border: '#BABABA',

  //orange
  orange50: '#FFFAF4',
  orange100: '#FEEAD2',
  orange200: '#FED5A5',
  orange300: '#FDAA4A',
  orange400: '#FC951D',
  orange500: '#CA7717',
  orange600_1: '#653C0C',
  orange700: '#321E06',

  //yellow
  yellow50: '#FFFCF3',
  yellow100: '#FEF5D0',
  yellow200: '#FDEBA1',
  yellow300: '#FBD644',
  yellow400: '#FACC15',
  yellow500: '#C8A311',
  yellow600: '#645208',
  yellow700: '#322904',

  //green
  green50: '#F3FAF6',
  green100: '#D0EDDB',
  green200: '#A2DAB7',
  green300: '#45B56E',
  green400: '#16A34A',
  green500: '#12823B',
  green600: '#09411E',
  green700: '#04210F',
  //purple
  purple50: '#F1EBFF',
  purple100: '#DED2F5',
  purple200: '#BDA6EB',
  purple300: '#7A4DD8',
  purple400: '#5920CE',
  purple500: '#471AA5',
  purple600: '#240D52',
  purple700: '#120629',
  //blue
  blue50: '#F3F8FE',
  blue100: '#D0E2FB',
  blue200: '#A1C5F7',
  blue300: '#448BEE',
  blue400: '#156EEA',
  blue500: '#1158BB',
  blue600: '#082C5E',
  blue700: '#04162F',
  //red
  red50: '#FDF4F4',
  red100: '#F8D4D4',
  red200: '#F1A8A8',
  red300: '#E35151',
  red400: '#DC2626',
  red500: '#B01E1E',
  red600: '#580F0F',
  red700: '#2C0808',
  //neutral
  neutral100: '#F8F8F8',
  neutral200: '#D7D7D7',
  neutral300: '#BABABA',
  neutral400: '#9B9B9B',
  neutral500: '#737373',
  neutral600: '#606060',
  neutral700: '#484848',
  neutral800: '#2E2E2E'
};

export const opacities = {
  opacity_5: '0D', // 5%
  opacity_10: '1A', // 10%
  opacity_16: '29' // 16%
};

export default colors;
